import { h, FunctionalComponent } from 'preact';
import { DelYeahContainer } from '../../../containers/DelYeahContainer';
import { TextField } from '@authentic/loyalty-pwa/components/Form/TextField';
import { LabelValue } from '@authentic/loyalty-pwa/components/Form/LabelValue';
import styled from 'styled-components';
import { route } from "@authentic/loyalty-pwa/util/route.util";

import {
  backgroundColors,
  breakpoints,
} from "@authentic/loyalty-pwa/util/variables";
import { FormHint, FormStyled } from '../../change-password/change-password.style';
import { Controller, useForm } from 'react-hook-form';
import { Button } from "@authentic/loyalty-pwa/components";
import { useContext, useState } from 'preact/hooks';
import { BackIcon } from '../../../icons/Back';
import { ReceiptServiceContext } from "@authentic/loyalty-pwa/providers";
import { ReceiptResponse } from '@authentic/loyalty-pwa/interfaces/receipt.service.interface';
import { Snackbar, SnackbarType } from '../../../components/snackbar/snackbar';
import { getImageSrc } from '@authentic/loyalty-pwa/util';


const WhiteBox = styled.div`
  padding: 0 0 30px;
  text-align: center;

  @media screen and (min-width: ${breakpoints.sm}) {
    background: ${backgroundColors.white};
    margin: 0 auto;
    max-width: 550px;
    padding: 25px 50px;
  }
`;

const FormControlStyled = styled.div`
  margin-bottom: 12px;
`;


const BackButton = styled.div`
  background: ${backgroundColors.white};
  margin: 0 auto;
  max-width: 550px;
  position: relative;
  
  button{
    background: #E7E7E7;
    color: black;
    border: 0;
    text-transform: uppercase;
    cursor: pointer;
    height: 63px;
  }
  @media screen and (max-width: ${breakpoints.sm}) {
    position: absolute;
    top: 235px;
    left: 0;
    width: 100%;
    max-width: 100%;
    button{
      background: #F7F7F7;
      color: black;
      text-transform: uppercase;
    }
  }
`

const BackIconStyle = styled.span`
  position: absolute;
  left: 18px;
`

const CouponStyled = styled.div`
  background: ${backgroundColors.white};
  padding: 50px 30px;

  @media screen and (min-width: ${breakpoints.sm}) {
    background: ${backgroundColors.lightGray};
  }
`;


const MessageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`


const MessageStyle = styled.div<{ error: boolean }>`
  background-color: ${(props: { error: boolean }) => (props.error ? '#DC4547' : '#40ad5f')};
  height: 60px;
  width: 320px;
  margin-top: 1px;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: white;
  text-align: center;
  display: flex;
  border-radius: 5px;
  box-shadow: 2px 2px 5px #999;
  margin-top: 10px;
  align-items: center;
  padding-left: 5px;
  
  b {
    padding-right: 3px;
    padding-left: 3px;
  }
`;

const MessageSpan = styled.span`
  flex-grow: 2;
  text-align: left;
  padding-left: 3px;
`

const CloseMessageButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
`;

const FormInformation = styled.div`
  margin-bottom: 20px;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
`;

const ExampleReceiptImageStyled = styled.div`
  margin: 48px auto 12px;
  img {
    width: 100%;
  }
`;

export const DelYeahEnterReceipt: FunctionalComponent = () => {
  const htmlTitle: string = "Manually add purchase to Del Yeah! Rewards";
  const htmlMetaDescription: string =
    "Your Del Yeah! Rewards Dashboard of available rewards and offers.";
  const IDItemMenuSelected: string = "5";
  const successMessage = 'Receipt Submitted';
  const [isConfirm, setConfirm] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState(SnackbarType.Success);
  const [transactionId, setTransaction] = useState('');
  const [title, setTitle] = useState('ENTER RECEIPT');
  const [orderDate, setOrderDate] = useState('');
  const [storeId, setStoreId] = useState('');
  const [amount, setAmount] = useState('');
  const receiptService = useContext(ReceiptServiceContext);

  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    setError,
    setValue,
    reset,
    getValues
  } = useForm();

  const onSubmit = (data: any) => {
    setTransaction(data.transaction_id);
    setOrderDate(data.order_date);
    setStoreId(data.store_id);
    setAmount(data.subtotal_amount.replace('$', ''));
    setTitle("RECEIPT DETAILS")
    setConfirm(true);
  };

  const getFormattedDate = (dateVal: string) => {
    const date = new Date(dateVal);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const day = date.getDate();
    return `${year}-${('0' + month).slice(-2)}-${('0' + day).slice(-2)}`;
  }
  const currencyFormatted = () => {
    const amount = (getValues().subtotal_amount).replace('$', '');
    console.log(amount)
    let i = parseFloat(amount);
    if (isNaN(i)) { i = 0.00; }
    let minus = '';
    if (i < 0) { minus = '-'; }
    i = Math.abs(i);
    i = parseInt("" + (i + .005) * 100);
    i = i / 100;
    let s = new String(i);
    if (s.indexOf('.') < 0) { s += '.00'; }
    if (s.indexOf('.') == (s.length - 2)) { s += '0'; }
    s = minus + s;
    setValue('subtotal_amount', '$' + s);
  }

  const confirmation = () => {
    receiptService?.registerClaim({
      transaction_id: transactionId,
      place_id: storeId.trim(),
      business_date: getFormattedDate(orderDate),
      subtotal: parseFloat(amount)
    }).then((res: ReceiptResponse) => {
      if (res.success) {
        setSnackbarType(SnackbarType.Success);
        setSnackbarMessage(successMessage);
      } else {
        if (res.message) {
          setSnackbarType(SnackbarType.Error);
          setSnackbarMessage(res.message);
        }
      }
      setOpenSnackbar(true);
    });
  }

  const back = () => {
    if (isConfirm) {
      setConfirm(false);
      setTitle("ENTER RECEIPT")
      reset();
      setValue("transaction_id", transactionId);
      setValue("order_date", orderDate);
      setValue("store_id", storeId);
      setValue("subtotal_amount", '$' + amount);
    } else {
      route('/your-history');
    }
  }

  const callbackOnCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>

      <CouponStyled>
        <BackButton>
          <Button fullWidth onClick={back}>
            <BackIconStyle><BackIcon /></BackIconStyle>{title}
          </Button>
        </BackButton>
        <WhiteBox>

          <FormStyled onSubmit={handleSubmit(onSubmit)}>
            {
              !isConfirm && (
                <FormControlStyled>
                  <FormHint>*Required Field</FormHint>
                  <FormInformation>Please enter the following information.</FormInformation>
                  <Controller
                    render={({ field }: any): any => (
                      <TextField
                        error={errors?.transaction_id}
                        label="Transaction ID"
                        mask="99999"
                        maskPlaceholder="     "
                        autoFocus
                        type="text"
                        required
                        {...field}
                        id="transaction_id"
                        toolTip="Find the five digit order ID above the items on your order. Example: 10203"
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: "Please enter a valid transaction id. Must be 5 digits",
                      },
                      pattern: {
                        value: /^\d{5}$/,
                        message: 'Please enter a valid transaction id. Must be 5 digits',
                      },
                    }}
                    control={control}
                    name="transaction_id"
                    defaultValue=""
                  />
                  <Controller
                    render={({ field }: any): any => (
                      <TextField
                        mask="99/99/9999"
                        maskPlaceholder="mm/dd/yyyy"
                        label="Order Date"
                        {...field}
                        required
                        error={errors?.order_date}
                        id="order_date"
                      />
                    )}
                    control={control}
                    name="order_date"
                    rules={{
                      required: {
                        value: true,
                        message: "Please enter a valid order date",
                      },
                      pattern: {
                        value: /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                        message: 'Please enter a valid order date',
                      },
                    }}
                    defaultValue=""
                  />
                  <Controller
                    render={({ field }: any): any => (
                      <TextField
                        error={errors?.store_id}
                        label="Store ID"
                        mask="99999999999"
                        maskPlaceholder="           "
                        type="text"
                        required
                        {...field}
                        id="store_id"
                        toolTip="Find the store number at the top or your receipt. You do not need to enter “Del Taco #” before the number."
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: "Please enter a numeric valid store id",
                      },
                    }}
                    control={control}
                    name="store_id"
                    defaultValue=""
                  />
                  <Controller
                    render={({ field }: any): any => (
                      <TextField
                        error={errors?.subtotal_amount}
                        label="Subtotal Amount"
                        type="text"
                        required
                        {...field}
                        onBlur={currencyFormatted}
                        id="subtotal_amount"
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: "Please enter a valid amount",
                      },
                      pattern: {
                        value: /^\$?(([1-9]\d{0,2}(,\d{3})*)|0)?\.\d{1,2}$/,
                        message: 'Please enter a valid amount',
                      },
                    }}
                    control={control}
                    name="subtotal_amount"
                    defaultValue=""
                  />
                  <div style={{ marginTop: '10px' }}>
                    <Button
                      ariaLabel="NEXT"
                      type="submit"
                      fullWidth
                    >
                      PROCEED TO CONFIRMATION
                    </Button>
                  </div>

                </FormControlStyled>
              )
            }
            {isConfirm && (
              <FormControlStyled>
                <FormInformation>Here's you summary.</FormInformation>
                <LabelValue label={'Transaction ID'} value={transactionId} />
                <LabelValue label={'Order Date'} value={orderDate} />
                <LabelValue label={'Store ID'} value={storeId} />
                <LabelValue label={'SubTotal'} value={amount} />
                <div style={{ marginTop: '20px' }}>
                  <Button
                    ariaLabel="NEXT"
                    onClick={confirmation}
                    fullWidth
                  >
                    SUBMIT
                  </Button>
                </div>
              </FormControlStyled>
            )}


            <ExampleReceiptImageStyled>
              <img src={getImageSrc(require('../../../assets/deltaco-sample-receipt.png').default)} alt="" />
            </ExampleReceiptImageStyled>
          </FormStyled>
        </WhiteBox>
      </CouponStyled>

      <Snackbar
        message={snackbarMessage}
        isActive={openSnackbar}
        type={snackbarType}
        timeout={10000}
        callbackOnClose={callbackOnCloseSnackbar}></Snackbar>
    </DelYeahContainer>
  );
}
